import { useEffect, useState } from "react";

const navLinks = [
  { href: "#overview", label: "片单总览" },
  { href: "#ranking", label: "排行榜" },
  { href: "#themes", label: "主题合集" },
  { href: "#new", label: "最新片单" },
  { href: "#classics", label: "经典高分" },
  { href: "#guide", label: "观影指南" },
  { href: "#faq", label: "常见问答" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) setMenuOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
      <nav className="mx-auto flex h-[68px] w-full max-w-[1280px] items-center justify-between px-4 md:px-6">
        <a href="#overview" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-950 text-primary-300">
            <i className="ri-film-line text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-base font-bold tracking-wide text-foreground-950">
              韩影片单
            </span>
            <span className="text-[11px] font-label tracking-wider text-foreground-500">
              韩国伦理电影在线观看
            </span>
          </span>
        </a>

        <ul className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-label text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#ranking"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-label font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            看排行榜
          </a>
          <button
            type="button"
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <ul className="mx-auto flex w-full max-w-[1280px] flex-col px-4 py-3 md:px-6">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="block rounded-md px-3 py-3 text-sm font-label text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}